export enum SyncVendor {
  Microsoft = 'Microsoft',
  Google = 'Google'
}
